import React from 'react'
import { useTranslation } from 'react-i18next'
import { Lock } from 'lucide-react'

/**
 * Заглушка «Краш временно недоступен» (§4: crash:disabled).
 *
 * Показывается вместо поля игры. Текущий раунд при этом доигрывается —
 * заглушку рисуем по приходу события, а не обрываем раунд на середине.
 * Список игроков чистим (crash:players в этом случае не придёт — §4).
 *
 * События «включили обратно» нет — заглушка снимается по следующему crash:round.
 */
const CrashDisabledStub = () => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="w-14 h-14 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center mb-4">
        <Lock className="w-7 h-7 text-red-400" />
      </div>
      <h3 className="text-lg font-bold text-red-300 mb-1">
        {t('crash.disabled.title')}
      </h3>
      <p className="text-sm text-text-secondary max-w-sm">
        {t('crash.disabled.description')}
      </p>
    </div>
  )
}

export default CrashDisabledStub
